<template>
  <main class="data-assistant-page">
      <!-- 数据统计 -->
      <div class="data-assistant-page-section-l">
        <!-- 我的数据助手 -->
        <DataAssistant @getTime="getTime"/>
        <!-- 详细数据 -->
        <DetailData 
          :startTime ="startTime"
          :endTime ="endTime"
        />
      </div>

  </main>
</template>

<script>
import moment from "moment";

import DetailData from '@/components/data-assitant/detailData';
import DataAssistant from '@/components/data-assitant/dataAssistant.vue';
export default {
  components: {
    DetailData,
    DataAssistant
  },
  data(){
    return {
      tableData: [],
      startTime: moment(new Date().setMonth(new Date().getMonth()-6)).format('YYYY-MM-DD'),
      endTime: moment().format('YYYY-MM-DD')
    }
  },
  methods:{
    getTime(startTime,endTime){
      this.startTime = startTime
      this.endTime = endTime
    },
  },
}
</script>

<style lang="scss">
.data-assistant-page {
  .model-title {
    display: inline-block;
    height: 14px;
    line-height: 14px;
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 14px;
    color: #16181A;
    letter-spacing: 0;
    text-align: justify;
    margin-bottom: 16px;
  }
  &-cont {
    margin-bottom: 12px;
  }
  &-section {
    display: flex;
    &-l {
      flex: 1;
    }
   
  }
  
}

</style>